/* Header */
const userMenuTxt = {
    'info': 'Mis datos',
    'account': 'Mi cuenta',
    'orders': 'Mis compras',
    'lists': 'Mis listas',
    'repeatOrder': 'Repetir última compra',
    'cards': 'Mis tarjetas',
    'logout': 'Cerrar Sesión'
};

const deliverySelectorTxt = {
    'deliveryMode': 'Modo de entrega',
    'delivery': 'Llevamos tu compra a',
    'express': 'Llevamos tu compra a',
    'store': 'Retira tu compra en',
    'car': 'Retira tu compra en',
    'notSelected': 'Aún no has seleccionado modo de entrega',
    'change': 'Cambiar',
    'select': 'Seleccionar',
};

const loginRegisterTxt = {
    'login': 'Ingresa',
    'register': 'Regístrate'
};

/* User Account */
const menuAccountTxt = {
    'info': userMenuTxt.info,
    'orders': userMenuTxt.orders,
    'lists': userMenuTxt.lists,
    'cards': userMenuTxt.cards
};

const accountInfoTxt = {
    'title': userMenuTxt.info,
};

const userDeliveryTxt = {
    'title': 'Mis direcciones',
    'btnSubmit': 'Agregar nueva dirección'
};

const userInfoTxt = {
    'title': 'Datos personales',
    'btnCancel': 'Cambiar clave',
    'btnSubmit': 'Cambiar datos',
};

const accountCardsTxt = {
    'title': userMenuTxt.orders,
    'filter': 'Filtrar',
    'btnSearch': 'Buscar'
};

const pastOrdersTxt = {
    'empty': 'Aún no tienes compras en Jumbo.cl',
    'subtitle': 'Navega por las categorías, realiza tus compras y aquí se guardarán',
    'btnSubmit': 'Comenzar a comprar',
    'viewMore': 'Ver más'
};

const accountListsTxt = {
    'title': userMenuTxt.lists,
    'empty': 'Todavía no tienes listas creadas.',
    'btnBuy': 'Comprar seleccionadas',
    'btnCreate': 'Crear nueva lista',
};

const accountCardListTxt = {
    'title': userMenuTxt.cards,
    'empty': 'Todavía no tienes listas creadas.',
    'btnBuy': 'Comprar seleccionadas',
    'btnCreate': 'Crear nueva lista',
};

const listItemTxt = {
    'btnBuy': 'Comprar',
    'btnSearch': 'Buscar productos',
    'btnRemove': 'Eliminar Lista',
    'btnEdit': 'Ver / Editar'
};

/* Modals */
const modalRegisterTxt = {
    'title': 'Crea tu cuenta',
    'subtitle': 'Por favor, ingresa los siguientes datos:',
    'btnCancel': 'Volver',
    'btnSubmit': 'Siguiente'
};

const modalReschedule = {
    'title': 'Reprograma tu pedido',
    'subtitle': 'Por favor, ingresa los siguientes datos:',
    'btnCancel': 'Cancelar',
    'btnSubmit': 'Ver Pedido'
};

const modalLoginTxt = {
    'title': 'Ingresa a tu cuenta',
    'subtitle': 'Por favor, ingresa los siguientes datos:',
    'btnCancel': loginRegisterTxt.register,
    'btnSubmit': loginRegisterTxt.login,
    'forgot': '¿Olvidaste tu clave?'
};

const modalDeliverySelectorTxt = {
    'title': 'Selecciona un modo de entrega',
    'noCoverage': 'Tu dirección está fuera de la zona de cobertura o no hay disponibilidad de despacho, comunícate con Servicio al Cliente o elige otro modo de entrega.',
    'storeUnavailable': 'Este local no tiene horarios disponibles.',
    'noWindows': 'En este momento no tenemos horarios disponibles para esta dirección.',
    'tryLater': 'Por favor intenta más tarde.',
    'btnSubmit': 'Confirmar',
    'btnAdd': 'Agregar dirección'
};



/* Checkout */
const dateDeliveryTxt = {
    'noWindows': modalDeliverySelectorTxt.noWindows,
    'tryLater': modalDeliverySelectorTxt.tryLater,
    'btnEdit': 'Selecciona uno diferente ó bien otro modo de entrega.',
    'storeUnavailable': modalDeliverySelectorTxt.storeUnavailable,
    'selectDate': 'No has seleccionado una fecha.',
    'selectTime': 'No has seleccionado una hora.',
    'calcFail': 'No pudimos calcular el tiempo de entrega.'
}

/* Footer */
const footerTxt = {
    'copyright': ' | Esta tienda está autorizada por Visa para realizar transacciones electrónicas. | Copyright © 2019 Cencosud - Jumbo '
};

const newsLetterTxt = {
    'title': 'Suscríbete a nuestras ofertas y novedades',
    'successTitle': '¡Ya estás registrado/a!',
    'successSubtitle': 'Pronto enviaremos a tu mail ofertas especialmente seleccionadas para ti.',
    'btnSubmit': 'Suscribir'
};

const preFooterTxt = {
    'faq': {
        'title': 'Cómo Comprar',
        'subtitle': 'Si tienes alguna duda ingresa aquí'
    },
    'stores': {
        'title': 'Nuestros Locales',
        'subtitle': 'Encuentra tu local Jumbo más cercano'
    },
    'delivery': {
        'title': 'Entrega',
        'subtitle': 'Conoce nuestros métodos de entrega'
    },
    'payment': {
        'title': 'Pago',
        'subtitle': 'Conoce nuestros medios de pago'
    }
};

/* Home & Landing Components*/
const sliderProductsTxt = {
    'viewMore': 'Ver todas las ofertas'
};

/* Breadcrumb */
const breacrumbTxt = {
    'home': 'Home'
};

export {
    modalRegisterTxt,
    modalLoginTxt,
    userDeliveryTxt,
    userInfoTxt,
    userMenuTxt,
    menuAccountTxt,
    deliverySelectorTxt,
    loginRegisterTxt,
    footerTxt,
    newsLetterTxt,
    preFooterTxt,
    sliderProductsTxt,
    breacrumbTxt,
    pastOrdersTxt,
    modalDeliverySelectorTxt,
    accountCardsTxt,
    accountListsTxt,
    listItemTxt,
    accountInfoTxt,
    dateDeliveryTxt,
    modalReschedule,
    accountCardListTxt
};
